import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";

import { IonicModule } from "@ionic/angular";

import { ConfirmSwapPage } from "./confirm-swap.page";

const routes: Routes = [
  {
    path: "",
    component: ConfirmSwapPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
  ],
  declarations: [ConfirmSwapPage],
})
export class ConfirmSwapPageModule {}
